import { KlydoMonitor, MonitorType } from "../../api/admin";

export const incidentClockIds = (monitor: KlydoMonitor): string[] => {
  if (monitor.targetType !== "clock") return [];
  return monitor.type === MonitorType.ClockInternal
    ? Array.from(
        new Set((monitor.failureReports ?? []).map((report) => report.clockId)),
      )
    : (monitor.incidentTargets ?? []);
};
